
import {
  db
} from '../main';

import { mapGetters } from "vuex";

//const jobNotesRef = db.ref("jobNotes");
//const changeLogRef = db.ref("changeLogs");
//const contactNotesRef = db.ref("contactNotes");

export default {
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    async saveNote(note, job, type, noteSavedMethod, flagJob, notesRef="jobNotes") {
      const t = this;
      console.log('t.user', t.user);

      var jobNote = {
        enteredUID: t.user.auth.uid,
        enteredby: t.user.data.name,
        submitted: new Date().toISOString(),
        type: type,
        message: note,
      }

      var saveRef;
      if(notesRef==="jobNotes"){
          saveRef = db.ref("changeLogs");
          jobNote.jobid = job.jobid;
          jobNote.jobUID = job['.key'];
      }else{
          saveRef = db.ref("changeLogsEnquiry");
          jobNote.contactid = job.contactid;
          jobNote.contactUID = job['.key'];
      }
      if (type === 'Note') {
        saveRef = db.ref(notesRef);
      }
      console.log('saveRef', saveRef);



      flagJob = job.assignedUID === t.user.auth.uid ? false : flagJob

      if (flagJob) {
        jobNote.viewFor = job.assignedTo;
        jobNote.viewForID = job.assignedUID;
      }

      saveRef
        .push(jobNote)
        .then((snap) => {
          const key = snap.key;
          console.log(key);
          console.log("note saved");

          if (flagJob) {
            job.hasNoteUserName = job.assignedTo;
            job.hasNoteUserID = job.assignedUID;
            job.hasNoteID = key;
    
            this.saveJob(job, notesRef);
          }


          if (noteSavedMethod) {
            noteSavedMethod("New Note Saved"); 
          }
        });
    },

    async viewNote(note, job, notesRef="jobNotes") {
      note.viewDate = new Date().toISOString();
      
      db.ref(notesRef+'/' + note['.key'])
      .set(note)
      .then(() => {
        console.log('note marked as viewed')
      })


      if(job.hasNoteID === note['.key']){
        delete job.hasNoteUserName;
        delete job.hasNoteUserID;
        delete job.hasNoteID;
        this.saveJob(job, notesRef)
      }



    },
    async deleteNote(note, job, notesRef="jobNotes") {
            db.ref(notesRef+'/' + note['.key']).remove();

            if(job.hasNoteID === note['.key']){
              delete job.hasNoteUserName;
              delete job.hasNoteUserID;
              delete job.hasNoteID;
              delete job.hasNoteFlagName;
              delete job.hasNoteFlagID;
              this.saveJob(job, notesRef)
            }

    },


    saveJob(job, notesRef){
      if(notesRef==="jobNotes"){
        db.ref('jobs2020/' + job['.key'])
        .set(job)
        .then(() => {
          console.log('job updated!')
        })
      }else{
        db.ref('contactForm2020/' + job['.key'])
        .set(job)
        .then(() => {
          console.log('contact updated!')
        })
      }
    }


  },
};
